import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import React from "react";
import { ColumnsEdit } from "types/models/column-table-edit";
import moment from "moment";
import {
  convertIosStringToDateDayjs,
  convertIosStringToDateMoment,
} from "helper/common";
import { DataFormField } from "types/models/input-field-type";

const { INPUT, SELECT, DATE, CHECKBOX } = FIELD_TYPE;

const dataField: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    //expand: true,
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "hoTen",
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
    //expand: true,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "soDienThoai",
    //expand: true,
  },
  {
    type: DATE,
    label: "Ngày nhận kính từ",
    name: "ngayNhanKinhTu",
    //expand: true,
    optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
  },
  {
    type: DATE,
    label: "Ngày nhận kính đến",
    name: "ngayNhanKinhDen",
    //expand: true,
    optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
  },
  {
    type: INPUT,
    label: "Cử nhân khúc xạ",
    name: "cuNhanKhucXa",
    //expand: true,
  },
  {
    type: INPUT,
    label: "Bác sĩ",
    name: "bacSi",
    //expand: true,
  },
];

const columnTable: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    // render: (text, record, index) => index + 1,
    align: "center",
    fixed: "left",
  },
  {
    title: "Tên bệnh nhân",
    dataIndex: "hoTen",
    key: "hoTen",
    width: "120px",
    align: "center",
    fixed: "left",
  },
  {
    title: "Ngày nhận kính",
    dataIndex: "ngayNhanKinh",
    key: "ngayNhanKinh",
    width: "110px",
    align: "center",
    render: (v) => convertIosStringToDateMoment(v),
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    key: "maBenhNhan",
    width: "70px",
  },
  {
    title: "Số điện thoại",
    dataIndex: "dienThoai",
    key: "dienThoai",
    width: "100px",
    align: "center",
  },
  {
    title: "Khúc xạ",
    dataIndex: "cuNhanKhucXa",
    key: "cuNhanKhucXa",
    width: "120px",
    align: "center",
  },
  {
    title: "Bác sĩ",
    dataIndex: "bacSi",
    key: "bacSi",
    width: "120px",
    align: "center",
  },
  {
    title: "Năm sinh",
    dataIndex: "ngaySinh",
    key: "ngaySinh",
    width: "100px",
    align: "center",
    render: (v) => (v ? moment(v).format(FORMAT_TIME.dayFull) : ""),
  },
  {
    title: "Gọi tái khám",
    dataIndex: "ttGoiTaiKham",
    key: "ttGoiTaiKham",
    width: "120px",
    align: "center",
    // render: (v) => (v ? moment(v).format(FORMAT_TIME.dayFull) : ""),
  },
  {
    title: "Tình trạng hiện tại",
    dataIndex: "tinhTrangHienTai",
    key: "tinhTrangHienTai",
    width: "120px",
    align: "center",
  },
  {
    title: "Ngày khám gần nhất(m/d/y)",
    dataIndex: "ngayKhamGanNhat",
    key: "ngayKhamGanNhat",
    width: "120px",
    render: (v) => (v ? moment(v).format(FORMAT_TIME.dayFull) : ""),
    align: "center",
  },
  {
    title: "Thời gian kể từ ngày tái khám (tháng)",
    dataIndex: "thoiGianKeTuTaiKham",
    key: "thoiGianKeTuTaiKham",
    width: "100px",
    // render: (v) => (v ? moment(v).format(FORMAT_TIME.dayFull) : ""),
    align: "center",
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    key: "diaChi",
    width: "120px",
    align: "left",
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    width: "80px",
    align: "center",
    fixed: "right",
  },
];

export { dataField, columnTable };
